import { PATH_DESCRIPTIONS } from "./pathDescriptions";
export var getPath = function getPath(name, path) {
  return PATH_DESCRIPTIONS[name] || path || PATH_DESCRIPTIONS['question mark'];
};